import { render, staticRenderFns } from "./hasElectricBoardLessThanTenYears.vue?vue&type=template&id=051dab6c&scoped=true"
import script from "./hasElectricBoardLessThanTenYears.vue?vue&type=script&lang=ts"
export * from "./hasElectricBoardLessThanTenYears.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051dab6c",
  null
  
)

export default component.exports